import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import Loader from '@components/Loader';
import Select from '@components/Select';
import lodash from "lodash";
import Icon from '@mui/material/Icon';
import { IconMap, ImagesGS } from '@src/constants/common';
import './POSPanel.scss';

const POSPanelPublic = ({ restaurants, isClassExtra }: any) => {
    // const [toggle, setToggle] = useState(false);
    const [selectedCat, setSelectedCat] = useState("add-ons");
    const [products, setProducts]: any = useState({});
    const [catOrder, setCatOrder] = useState([]);
    // const [restaurantDetails, setRestaurantDetails]: any = useState({});
    const [selectMap, setSelectMap]:any = useState({});
    // const dispatch = useDispatch();
    let params = useParams();


    useEffect(() => {
        restaurants?.length && restaurants?.filter((res: any) => res?.docId === params?.restaurantId).forEach((item: any) => {
            setProducts(item?.menu);
            setCatOrder(item?.categoryOrder || []);
            // setRestaurantDetails(item);
            setSelectedCat((item?.categoryOrder?.length && item?.categoryOrder[0]) || Object.keys(item?.menu)[0] || "add-ons");
        });
    }, [restaurants, params?.restaurantId]);

    const handleSelectChange = (val: any, key: any) => {
        setSelectMap({ ...selectMap , [key]: val })
    };

    const handleSelectBlur = (event: any) => {
        event.stopPropagation();
    };

    return (
        <div className={`detailsPageWrap ${isClassExtra && "extra"}`}>
            <ul className='menuNav'>
                {
                    ((!!catOrder.length && catOrder) || (!!products && Object.keys(products).sort()) || []).map((key: any, _index: any) => (
                        <li key={key} onClick={() => setSelectedCat(key)} className={key === selectedCat ? "selected" : ""}>
                            {/* <RenderDynamicIcon className="iconMenu" name="Fastfood" /> */}
                            <p className="textMenu">&nbsp;{key.split("-").join(" ")}</p>
                            {IconMap[key] && <Icon color="primary" className='menuIconDynamic'>{IconMap[key]}</Icon>}
                        </li>
                    ))
                }
            </ul>
            <div className='menuList'>
                {!products && <Loader />}
                <div key={selectedCat}>
                    <h4 className='heading--h4'>
                        &nbsp;{selectedCat.split("-").join(" ")}</h4>
                    <Box
                        className='product-item'
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            '& > :not(style)': {
                                m: 1,
                                width: 200,
                                height: 100,
                            },
                        }}
                    >
                        {
                            
                            !!products[selectedCat] && lodash.sortBy(Object.entries(products[selectedCat]), [function(o: any){return o[1].order}]).map(([keyP, catP]: any, _indexP: any) => {
                                if (catP.hideInOnlineMenu) {
                                    return null;
                                }
                                const _selVar = selectMap[selectedCat + '-' + keyP] || { value: catP.variants[0].cost, label: `₹${catP.variants[0].cost} / ${catP.variants[0].size}` };
                                return (
                                    <div key={selectedCat + '-' + keyP} className={`card-wrap food-type food-type_${catP.type}`} >
                                        <Paper elevation={3}>
                                            <span className='product-item__image'>
                                                <img src={catP.image || ImagesGS.itemPlaceholder} title={keyP} alt={selectedCat} />
                                            </span>
                                            <span className='item-wrap'>
                                                <p className='item__name'>{!!keyP && keyP.replaceAll("-", " ")}</p>
                                                {/* <p className='item__price'>{catP.variants[0].cost} / {catP.variants[0].size}</p> */}
                                                <div onClick={(catP.variants.length > 1) ? handleSelectBlur : ()=>{}}>
                                                    <Select
                                                        className="selectWrap"
                                                        onChange={(val: any) => handleSelectChange(val, selectedCat+'-'+keyP)}
                                                        defaultValue={{ value: catP.variants[0].cost, label: `₹${catP.variants[0].cost} / ${catP.variants[0].size}` }}
                                                        options={catP.variants.map((val: any) => ({ value: val.cost, label: `₹${val.cost} / ${val.size}`}))}
                                                        isDisabled={!(catP.variants.length > 1)}
                                                    />
                                                </div>
                                            </span>
                                        </Paper>
                                    </div>
                                )
                            })
                        }
                    </Box>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state: any) => {
    const { common, cart, user: _user } = state;
    return {
        cart: (cart && cart[common?.selectedRestaurant?.docId]) || {},
        isClassExtra: Object.entries(common?.selectedRestaurant?.tabs || {}).length > 1,
        restaurants: common?.restaurants,
        // roles: user?.user?.roles
    }
}

export default connect(mapStateToProps)(POSPanelPublic);
